export default {
  design: {
    title: 'Ontwerp',
  },

  detail: {
    leaveConfirmation: 'Bent u zeker dat u wilt weggaan? Alle aanpassingen zullen verloren gaan.',
    leaveTitle: 'Bevestiging',
  },

  filters: {
    cw_class_kettle: 'CW Klasse CV Ketel',
    gas_connection_type: 'Aansluiting Rookgas',
    heat_pump_power: 'Vermogen Warmtepomp (7°C / 35°C)',
    heat_pump_series: 'Product Warmtepomp',
    heat_pump_type: 'Type Warmtepomp',
    kettle_series: 'Product CV',
    kettle_type: 'CV Ketel',
  },

  info: {
    products: 'Hoofdproducten in deze configuratie',
    sap: 'Bestelcode',
    select: 'Selecteer systeem',
  },

  overview: {
    noData: 'Geen systemen gevonden',
  },

  quote: {
    info: 'Hieronder vindt u het totaaloverzicht van de producten en geselecteerde accessoires incl bijbehorende prijzen. Accessoires kunnen uit de lijst worden gehaald door het selectievakje te verschuiven. Items zonder schuiffunctie zitten standaard in de leveringsomvang.',
    footer: 'Bovenstaande prijzen zijn brutoprijzen. Uw inkoopsprijs kunt u met bovenstaand overzicht opvragen bij uw groothandel waarmee u zaken doet.',
    calculation: {
      subtotalExclVAT: 'Subtotaal (excl. BTW):',
      subtotalInclVAT: 'Subtotaal (incl. BTW):',
      total: 'Totaal:',
      vat: 'BTW:',
    },
    columns: {
      amount: 'Aantal',
      price: 'Prijs',
      name: 'Naam',
      serial_number: 'Bestelcode',
      subtotal: 'Subtotaal',
      vat_percentage: 'BTW %',
      vat_total: 'BTW €',
    },
    system: 'Systeem',
    title: 'Offerte',
  },

  share: {
    addMessage: 'Bericht toevoegen',
    addManual: 'Ontwerphandleiding toevoegen',
    billMaterials: 'Materiaalbon',
    date: 'Datum',
    defaultMessage: 'Beste, \n\nHierbij sturen wij u in de bijlage van deze e-mail de offerte.\n\nMocht u nog vragen hebben dan horen wij dit graag.\n\nMet vriendelijke groeten,',
    download: 'Download',
    editSubject: 'Email onderwerp aanpassen',
    editSubjectPlaceholder: 'Vul een onderwerp in...',
    emailPlaceholder: 'Vul een e-mailadres in...',
    failure: 'Er ging iets fout. Probeer het later nog eens opnieuw.',
    loading: 'Laden...',
    manual: 'Ontwerphandleiding',
    quote: 'Offerte',
    quoteNumber: 'Offerte nummer',
    sendDuplicate: 'Stuur een kopie naar mij',
    shareViaMail: 'Deel via e-mail',
    success: 'Project werd succesvol verzonden.',
    systemSketch: 'Systeemschets',
    title: 'Verzenden',
    totalAmount: 'Totaal aantal',
    validUntil: 'Geldig tot',
  },

  sorting: {
    nameAsc: 'Naam A - Z',
    nameDesc: 'Naam Z - A',
    priceAsc: 'Prijs laag - hoog',
    priceDesc: 'Prijs hoog - laag',
  },

  title: 'Systemen',

};



// WEBPACK FOOTER //
// ./js/lang/nl/systems.js